import { Fragment, useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Button, Col, Divider, Grid, Image, Row, Space, Tag, Typography } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';
import classNames from 'classnames';

import FilterAccordion from 'src/components/Filter/FilterAccordion';
import messageC from 'src/components/Message';
// import messageC from 'src/components/Message';
// import ModalShare from 'src/components/Profile/InviteFriends/Share/ModalShare';
import g from 'src/constants/global';
// import defaultPagination from 'src/constants/pagination';
// import useInsiderTrackingArticle from 'src/hooks/useInsiderTrackingArticle';
import { ISection } from 'src/interface';
import deviceSizeC from 'src/utils/device-size-client';
import { formatDateListArticels } from 'src/utils/func/format-date';
import { renderDetailArticle } from 'src/utils/func/render-article';
import layoutMobile from 'src/utils/layout-mobile';

import classes from './style.module.less';

const GPT = dynamic(() => import('src/components/GPT'), { ssr: false });
const ArticleDetail = (props: any) => {
	const { xl, lg, xs } = Grid.useBreakpoint();
	const router = useRouter();
	const lm = layoutMobile(router);
	const article = props;
	const url = `${process.env.NEXT_PUBLIC_WEB_URL}${router.asPath?.split('?')[0]}`;
	const copyLink = () => {
		const cb = navigator.clipboard;

		cb.writeText(`${window.location.origin}${router.asPath?.split('?')[0]}`).then(() => {
			messageC('Copied');
		});
	};
	const sosmed = {
		social_media: [
			{
				icon: '/images/default/logoFbColor.svg',
				name: 'Facebook',
				deeplink: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
			},
			{
				icon: '/images/default/logoXColor.svg',
				name: 'Twitter',
				deeplink: `https://twitter.com/intent/tweet?url=${url}`,
			},
			{
				icon: '/images/default/logoWaColor.svg',
				name: 'WA',
				deeplink: `https://api.whatsapp.com/send?text=${url}`,
			},
			{
				icon: '/images/default/logoCopy.svg',
				name: 'copylink',
				deeplink: '',
			},
		],
	};
	// const [showModalShare, setShowModalShare] = useState(false);
	// const article: IArticleByGroupDetail = useSelector(
	// (state: RootStateOrAny) => state.articleByGroup.detail,
	// );
	const channel = article.categories?.length > 0 ? article.categories[0].full_slug.split('/') : [];

	// const copy = (text: any) => {
	// navigator.clipboard.writeText(text);
	// messageC('Tautan berhasil disalin');
	// };
	const breakpoint = Grid.useBreakpoint();
	const pageBreaks = useMemo(() => {
		return article?.sections?.filter((s: any) => s.type === 'PageBreakSection');
	}, [article]);
	const renderDivider = (section: ISection) => {
		return (
			pageBreaks &&
			pageBreaks.map((pb: any, index: any) => {
				if (pb.uid === section.uid) {
					return (
						<Divider key={pb.uid} plain className={classes.divider}>
							{`${index + 1} dari ${pageBreaks.length}`}
						</Divider>
					);
				}
			})
		);
	};

	const getContentArticleClass = (type: string) => {
		switch (type) {
			case 'TextSection':
				return '';
			case 'PageBreakSection':
				return classes['page-break-section'];
			default:
				return '';
		}
	};
	const [imageBroken, setImageBroken] = useState(String);

	return (
		<div className={classes['wrap-article-detail']}>
			<h1 className={classes.title}>{article.title}</h1>
			<Row>
				<Col className="d-flex align-items-center">
					<Text className="fs-14 fs-md-16">
						{!article.author_name ?<span style={{color:'#F48A8A', fontWeight: '500'}}>Tim Ahli Hallobumil </span>:<a href={`/author/${article.author_slug}`}><span style={{color:'#F48A8A', fontWeight: '500'}}>{article.author_name} {' '}</span></a>}
						 | Diterbitkan pada {formatDateListArticels(article.publish_date)}
					</Text>
				</Col>
			</Row>
			<Row>
				<Col className="d-flex align-items-center">
					<Text className="fs-14 fs-md-16" style={{ color: '#A19797'}}>
						Ditinjau oleh {!article.reviewer_name ?<span style={{color: '#4A4545', fontWeight: '500'}}>Tim Ahli Hallobumil </span>:<a href={`/author/${article.reviewer_slug}`}><span style={{color: '#4A4545',fontWeight: '500', textDecoration: 'underline'}}>{article.reviewer_name}</span></a>}
					</Text>
				</Col>
			</Row>
			<Row style={{ paddingTop: '20px', paddingBottom: '20px' }}>
				<Col md={17} xs={12}>
					{article.cmp_article_category?.find((x: any) => x.is_primary) && (
						<Button
							className={classNames(classes.category, { [classes['category-mobile']]: lm })}
							style={{
								backgroundColor: '#ffffff',
								color: '#F48A8A',
								border: '1px solid #F48A8A',
								cursor: 'pointer',
							}}
							href={
								article.type === 'post-pregnancy'
									? '/pasca-kehamilan'
									: article.type === 'pre-pregnancy'
									? '/pra-kehamilan'
									: article.type === 'pregnancy'
									? '/kehamilan'
									: article.type === 'recipe'
									? '/resep'
									: '/artikel'
							}
							id={
								article.type === 'post-pregnancy'
									? 'detail-artikel-pasca-kehamilan'
									: article.type === 'pre-pregnancy'
									? 'detail-artikel-pra-kehamilan'
									: article.type === 'pregnancy'
									? 'detail-artikel-kehamilan'
									: article.type === 'recipe'
									? 'detail-artikel-resep'
									: 'detail-artikel-semua-topik'
							}
						>
							{article.type === 'post-pregnancy'
								? 'Pasca Kehamilan'
								: article.type === 'pre-pregnancy'
								? 'Pra Kehamilan'
								: article.type === 'pregnancy'
								? 'Kehamilan'
								: article.type === 'recipe'
								? 'Resep Makanan'
								: 'Artikel'}
						</Button>
					)}
				</Col>
				<Col md={7} xs={12}>
					<Space className={classes.icons} size="middle">
						<Paragraph>
							<Typography className={classes.sosmed}>Bagikan</Typography>
						</Paragraph>
						{sosmed.social_media?.map((item: any) => {
							return item.name !== 'copylink' ? (
								<Fragment key={item.name}>
									<a
										href={item.deeplink}
										rel="nofollow noreferrer"
										id={'detail-artikel-' + item.name}
										target="_blank"
									>
										{item.icon && (
											<Image
												key={item.name}
												className={classes['socmed-icon']}
												width={!xl && lg ? 28 : xs ? 16 : 32}
												height={!xl && lg ? 28 : xs ? 16 : 32}
												src={item.icon}
												alt={item.name}
												preview={false}
												style={{ cursor: 'pointer' }}
											/>
										)}
									</a>
								</Fragment>
							) : (
								<Fragment key={item.name}>
									<div onClick={copyLink} id="CopyLink">
										{item.icon && (
											<Image
												key={item.name}
												className={classes['socmed-icon']}
												width={!xl && lg ? 28 : xs ? 16 : 32}
												height={!xl && lg ? 28 : xs ? 16 : 32}
												src={item.icon}
												alt={item.name}
												preview={false}
												style={{ cursor: 'pointer' }}
											/>
										)}
									</div>
								</Fragment>
							);
						})}
					</Space>
				</Col>
			</Row>

			<Row>
				<Col className="d-flex align-items-center">
					<Text className="fs-14 fs-md-16">{article.short_desc}</Text>
				</Col>
			</Row>
			<div className={classes['article-contents']}>
				<div style={{ textAlign: 'center' }}>
					<Image
						alt={article.slug}
						src={
							article?.media_images_new?.original === imageBroken
								? 'images/default/no-image.svg'
								: article?.media_images_new?.original
						}
						className={classes.imageContainer}
						style={{
							borderRadius: '20px',
							objectFit: 'cover',
							height: `${xs ? '230px' : '478px'}`,
							width: `${xs ? '330px' : '850px'}`,
							marginBottom: '24px',
							marginTop: '24px',
						}}
						preview={false}
						onError={() => {
							setImageBroken(article.media_images?.original);
						}}
					/>
				</div>
				{article?.sections?.map((s: ISection, i: number) => {
					const contentArr = s.content.split('</p>');
					return (
						<section key={s.uid}>
							{s.content && (
								<div className={getContentArticleClass(s.type)}>
									{s.type === 'PageBreakSection' && renderDivider(s)}

									{i === 0 ? (
										contentArr.map((paragraph: string, pi: number) => {
											return (
												<Fragment key={pi}>
													{pi === 2 && deviceSizeC(breakpoint) === 'desktop' && (
														<GPT
															name="gpt-ad-detail-general-article-leaderboard"
															adUnit={g.AD.DTL_ARTICLE_LEADERBOARD_UNIT}
															size={g.AD.DTL_ARTICLE_LEADERBOARD_SIZE}
															target={[
																['channel', channel],
																['article_id', [article.uid]],
															]}
															style={{ margin: '10px 0', overflow: 'hidden' }}
														/>
													)}
													{pi === 2 && deviceSizeC(breakpoint) === 'mobile' && (
														<GPT
															name="gpt-ad-detail-general-article-mobile-mrec"
															adUnit={g.AD.DTL_ARTICLE_MOBILE_MEDIUMREC_UNIT}
															size={g.AD.DTL_ARTICLE_MOBILE_MEDIUMREC_SIZE}
															target={[
																['channel', channel],
																['article_id', [article.uid]],
															]}
															style={{ marginBottom: 10, overflow: 'hidden' }}
														/>
													)}
													<div
														key={pi}
														className={classes['article-image']}
														dangerouslySetInnerHTML={{
															__html: `${renderDetailArticle(paragraph)}</p>`,
														}}
													/>
												</Fragment>
											);
										})
									) : (
										<div
											className={classes['article-image']}
											dangerouslySetInnerHTML={{ __html: renderDetailArticle(s.content) }}
										/>
									)}
								</div>
							)}
						</section>
					);
				})}
				<Row>
					{article.tags?.map((tag: any, index: any) => {
						return (
							<Tag className={classes['tag-article']} key={index}>
								{tag.name}
							</Tag>
						);
					})}
				</Row>
				{article.reference.length > 12 && (
					<div className={classes['accordion-reference']}>
						<FilterAccordion accordionHeader="Referensi" accordionKey="Referensi">
							<div dangerouslySetInnerHTML={{ __html: article.reference }} />
						</FilterAccordion>
					</div>
				)}
			</div>
		</div>
	);
};

export default ArticleDetail;
